import React from 'react';

export default function Cornerstone({value}) {
  return <a className="btn btn-primary" href={value.cornerstone_link} target="_blank">{value.button_title || 'Donate Now'}</a>;
}
